import { z } from 'zod';

export const CorePicklistItemScalarFieldEnumSchema = z.enum(['id','value','order','picklistId','deactivatedAt','createdAt','updatedAt','rowTimestamp']);

export default CorePicklistItemScalarFieldEnumSchema;
